// extracted by mini-css-extract-plugin
export default {"PartialWidthContainer__small":"PartialWidthContainer_PartialWidthContainer__small__P2hZ2","Body":"PartialWidthContainer_Body__doCJm"};